import { InjectionToken } from '@angular/core';

export const AUTH_PROVIDER_CONFIG = new InjectionToken<any>('auth-provider.config');

export abstract class AuthProvider {
    resetPwd: (username: string) => Promise<void>;
    resetPasswordSubmit: (username: string, code: string, newPassword: string) => Promise<void>;
}
